<template>
   <div class="watch-stream" v-if="streamDetail.key">
      <EndStreamScreen />
      <div class="watch-stream__wrapper" v-if="!streamEnded">
         <div class="row no-gutters watch-stream__top-content">
            <ViewLikeCount class="watch-stream__view-like-count no-phone-display" />

            <!-- Show Debug -->
            <div v-if="isShowDebug">
               <span class="mr-2 p-2 text-white bg-danger">Show Debug</span>
               <SwitchCheckbox v-model="showingDebug"></SwitchCheckbox>
            </div>
            <!-- End Show Debug -->

            <div class="watch-stream__toolbar-right">
               <div class="watch-stream__view-like-count bg-light-gray text-uppercase" v-if="streamDetail.artistShopUrl" @click="gotoShop()">
                  <b-img class="icon mr-1" src="@/assets/media/icons/shop-icon.png" />Shop
               </div>
               <a
                  :href="streamDetail.artistOfficialUrl"
                  v-if="streamDetail.artistOfficialUrl"
                  target="_blank"
                  class="watch-stream__offical-button watch-stream__offical-button--sm bg-light-gray"
               >
                  <span class="mr-2">{{ streamDetail.artistOfficialButton }}</span>
                  <b-icon icon="chevron-right" />
               </a>
               <div v-click-outside="hideMenu" class="watch-stream__dropdown ml-3">
                  <font-awesome-icon @click="showDropdownMenu = !showDropdownMenu" class="icon" icon="ellipsis-v" />
                  <div v-if="showDropdownMenu" class="watch-stream__dropdown-content">
                     <ul class="watch-stream__list-group">
                        <li
                           class="watch-stream__list-group-item"
                           :class="{ 'watch-stream__list-group-item--disabled': !streamStatistic.enable_chat }"
                        >
                           チャットを表示
                           <SwitchCheckbox :disabled="!streamStatistic.enable_chat" v-model="showComment"></SwitchCheckbox>
                        </li>
                        <!-- <li class="watch-stream__list-group-item" v-if="streamDetail.artistOfficialUrl">
                           <a :href="streamDetail.artistOfficialUrl" target="_blank">ヘルプ</a>
                        </li> -->
                        <li class="watch-stream__list-group-item">
                           <a href="https://keiba.rakuten.co.jp/?l-id=rakutenlive_pmenu_top" target="_blank">楽天競馬トップへ</a>
                        </li>
                        <!-- <li class="watch-stream__list-group-item" style="cursor:pointer" @click="logout()">ログアウト</li> -->
                     </ul>
                  </div>
               </div>
            </div>
         </div>
         <div class="watch-stream__video-box">
            <AnimationHeart class="animation-heart-wrapper__landscape" />
            <div class="watch-stream__video-player">
               <!-- :token="videoTokens.token"
                      :type-token="videoTokens.type"
                                         :base-url="streamDetail.baseUrl"
                       -->
               <VideoJsPlayer
                  ref="videoJsPlayer"
                  v-if="urlSources.length"
                  :url-sources="urlSources"
                  :force-auto-play-with-sound="true"
                  :key="reRenderVideoPlayer"
                  :useConvivaTracking="false"
                  :convivaMetadata="trackingMetadata"
                  @updateUrlPlaying="handleUpdateUrlPlaying"
                  @onExitFullscreen="handleExitFullscreen()"
                  @addQualityLevel="addQualityLevel"
                  @loadedmetadata="loadedMetaData"
                  @timeUpdate="onTimeVideoUpdate"
                  @updateStateShowResumeVideo="updateStateShowResumeVideo"
               >
               </VideoJsPlayer>
            </div>
            <div class="watch-stream__mobile-actions">
               <SeekbarVideo
                  :current-playing-time="currentPlayingTime"
                  :video-duration="videoDuration"
                  :is-video-playing="!isShowResumeVideo"
                  @setPlayer="setPlayer"
                  @setCurrentTime="setTimePlayer"
                  :is-live="isLive"
                  v-if="videoDuration > 0"
               />
               <b-dropdown
                  size="lg"
                  variant="link"
                  class="quality-icon"
                  menu-class="watch-stream__list-group"
                  toggle-class="mr-5 text-decoration-none"
                  no-caret
               >
                  <template #button-content>
                     <b-icon class="icon" icon="gear-fill" />
                     <b-badge class="video-quality-badge" pill variant="light">{{ getSelectedQuality }}</b-badge>
                  </template>
                  <b-dropdown-item-button
                     v-for="(quality, index) in getListQuality"
                     :key="index"
                     :active="quality.selected"
                     @click="changeVideoQuality(quality.height)"
                     >{{ quality.text }}</b-dropdown-item-button
                  >
               </b-dropdown>
               <b-icon class="icon icon--sm fullscreen-icon" icon="fullscreen" @click="handleFullscreen()" />
            </div>
            <div class="watch-stream__banner">
               <div class="watch-stream__banner-title">{{ streamDetail.title }}</div>
               <ViewLikeCount class="my-2" />
               <a
                  id="offical-button-phone"
                  :href="streamDetail.artistOfficialUrl"
                  v-if="streamDetail.artistOfficialUrl"
                  target="_blank"
                  class="watch-stream__offical-button"
               >
                  <span class="mr-2">{{ streamDetail.artistOfficialButton }}</span>
                  <b-icon icon="chevron-right" />
               </a>
            </div>
         </div>
         <div class="watch-stream__content">
            <div class="watch-stream__actions-wrapper">
               <div class="watch-stream__stream-actions">
                  <ChatBox
                     v-show="showComment"
                     :showAds="showAds"
                     :showing-debug="showingDebug"
                     :url-sources="urlSources"
                     :url-playing="urlPlaying"
                     @updateUrlTesting="updateUrlTesting"
                     ref="chatBox"
                  />
                  <div :class="`watch-stream__actions`">
                     <AnimationHeart class="animation-heart-wrapper" />
                     <div class="watch-stream__bg-circle">
                        <FlyingHeart icon-class="icon icon--lg" @onLiked="onHandleLiked"></FlyingHeart>
                     </div>
                     <div class="watch-stream__bg-circle icon-quality mt-5">
                        <!-- <img id="share-icon-btn" :data-clipboard-text="getCurrentLink" class="icon" src="@/assets/media/icons/share.png" /> -->
                        <b-dropdown
                           size="lg"
                           variant="link"
                           class="quality-icon quality-icon--land"
                           menu-class="watch-stream__list-group"
                           toggle-class="ml-5 text-decoration-none"
                           no-caret
                        >
                           <template #button-content>
                              <b-icon class="icon" icon="gear-fill" />
                              <b-badge class="video-quality-badge" pill variant="light">{{ getSelectedQuality }}</b-badge>
                           </template>
                           <b-dropdown-item-button
                              v-for="(quality, index) in getListQuality"
                              :key="index"
                              :active="quality.selected"
                              @click="changeVideoQuality(quality.height)"
                              >{{ quality.text }}</b-dropdown-item-button
                           >
                        </b-dropdown>

                        <b-icon class="icon ml-5 fullscreen-icon--land" icon="fullscreen" @click="handleFullscreen()" />
                     </div>
                  </div>
               </div>
               <SeekbarVideo
                  :current-playing-time="currentPlayingTime"
                  :video-duration="videoDuration"
                  :is-live="isLive"
                  :is-video-playing="!isShowResumeVideo"
                  @setPlayer="setPlayer"
                  @setCurrentTime="setTimePlayer"
                  class="seekbar-desktop"
                  v-if="videoDuration > 0"
               />
               <div v-if="toast.show" class="watch-stream__toast">{{ toast.message }}</div>
            </div>
         </div>
         <div class="watch-stream__overlay" v-show="isShowResumeVideo" @click="resumePlayVideo()">
            <div class="hover-play-img">
               <b-img src="@/assets/media/icons/play-icon.png" alt="play" class="play-icon"></b-img>
            </div>
         </div>
      </div>
   </div>
   <div class="watch-stream" v-else>
      <img v-if="event.image" class="w-100" style="height:auto;object-fit:cover" :src="event.image" alt="event-image" />
   </div>
</template>

<script>
import WatchStream from "../assets/js/pages/watch-stream";
export default WatchStream;
</script>

<style lang="scss">
@import "../assets/scss/pages/watch-stream";
</style>
